import { render, staticRenderFns } from "./VuejsFrontendDeveloper.vue?vue&type=template&id=68bc0d82&scoped=true&"
import script from "./VuejsFrontendDeveloper.vue?vue&type=script&lang=js&"
export * from "./VuejsFrontendDeveloper.vue?vue&type=script&lang=js&"
import style0 from "./VuejsFrontendDeveloper.vue?vue&type=style&index=0&id=68bc0d82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bc0d82",
  null
  
)

export default component.exports